import { Box, CircularProgress } from "@mui/material";

const Loading = () => {
	return (
		<Box
			p={1}
			width={1}
			height={1}
			display="flex"
			justifyContent="center"
			alignItems="center">
			<CircularProgress />
		</Box>
	);
};

export default Loading;
